import LazyLoad from "vanilla-lazyload/dist/lazyload";

const eagerThreshold = 800;

/* eslint-disable camelcase */

// Trick to force lazy modules ellipsis rendering
jQuery.fn.redraw = function() {
    return this.hide(0, function() {
        $(this).show();
    });
};

export default function() {

    function lazyLoadPolyfill() {

        $('.eager-html-uncomment, .lazy-html-uncomment').each(function() {
            callbackHtmlUncomment(this);
        });

        $('.eager-html-snippet, .lazy-html-snippet').each(function() {
            callbackSnippet(this);
        });
    }

    function callbackHtmlUncomment(el) {
        let $el = $(el);
        // jQuery .html() evaluates script tags
        $el.html($el.html().replace( '<!--LF[', '' ).replace( ']FL-->', '' ));
    }

    function callbackSnippet(el) {
        let $el = $(el);
        $.get($el.attr('data-sources'), function(data) {
            // jQuery .html() evaluates script tags
            $el.html(data);

            window.setTimeout(function(){
              $(this).find('.ellipsis').redraw(); // Redraw ellipsis
            }, 500);

        });
    }

    try {

        new LazyLoad({
            elements_selector: ".eager-html-uncomment",
            threshold: eagerThreshold,
            data_src: "src",
            callback_enter: callbackHtmlUncomment,
            callback_error: function(error) {
                console.log('lazy-load-error', error);
            }
        });

        new LazyLoad({
            elements_selector: ".eager-html-snippet",
            threshold: eagerThreshold,
            data_src: "src",
            callback_enter: callbackSnippet,
            callback_error: function(error) {
                console.log('lazy-load-error', error);
            }
        });

        new LazyLoad({
            elements_selector: ".lazy-html-uncomment",
            data_src: "src",
            callback_enter: callbackHtmlUncomment,
            callback_error: function(error) {
                console.log('lazy-load-error', error);
            }
        });

        new LazyLoad({
            elements_selector: ".lazy-html-snippet",
            data_src: "src",
            callback_enter: callbackSnippet,
            callback_error: function(error) {
                console.log('lazy-load-error', error);
            }
        });

    } catch(e) {
        lazyLoadPolyfill();
    }
}



// WEBPACK FOOTER //
// ./js/lazy-load/HtmlLazyload.js